import FlexBox from '@/atomic-components/FlexBox';
import {
	IBuyCartItems,
	ICartItem,
	IRentCartItem,
	LineOfProduct,
} from '@/services/cart/models/cart';
import { getColor } from '@/utils/theme/colors';
import { Box } from '@mui/material';
import { LencoTypography } from '@/atomic-components/LencoTypography';
import { roundPrice } from '@/utils/common';
import { getStyle } from '@/utils/theme/fonts';

type TCartItemSummaryProps = {
	item: ICartItem;
	isDrawer?: boolean;
};

const CartItemSummary = (props: TCartItemSummaryProps) => {
	const { item } = props;

	const priceToDisplay =
		item.lineOfProduct == LineOfProduct.RENT
			? (props.item as IRentCartItem).monthlyRentalPrice?.value
			: (props.item as IBuyCartItems).sellingPrice?.value;

	return (
		<Box>
			<FlexBox alignItems='start' gap='2rem' width='100%'>
				<LencoTypography
					variant='P_Medium'
					color={getColor('Gray 0')}
					className='cursor-pointer'
					sx={{ width: '60%' }}
				>
					{item.product.name}
				</LencoTypography>
				{item.availableQuantity > 0 && item.availableQuantity < 10 && (
					<Box
						sx={{
							...getStyle('Tiny_Medium'),
							color: getColor('Gray -1'),
							backgroundColor: getColor('Danger -4'),
							padding: '8px 16px',
							minWidth: 'max-content',
							borderRadius: '16px',
						}}
					>
						{item.availableQuantity} in stock
					</Box>
				)}
				{!props?.isDrawer &&
					item.availableQuantity == 0 &&
					item?.isOutOfStock && (
						<Box
							sx={{
								...getStyle('Tiny_Medium'),
								color: getColor('Gray -1'),
								backgroundColor: getColor('Danger -4'),
								padding: '8px 16px',
								minWidth: 'max-content',
								borderRadius: '16px',
							}}
						>
							OUT OF STOCK
						</Box>
					)}
			</FlexBox>

			<FlexBox mt='12px' alignItems={'center'}>
				<LencoTypography
					variant='Tiny_Medium'
					color={getColor('Gray -4')}
					sx={{ textDecoration: 'line-through' }}
					mr='8px'
				>
					₹{roundPrice(item.strikePrice.value)}
					{item?.lineOfProduct === 'RENT' && <span style={{ fontWeight: 400 }}>/mo</span>}
				</LencoTypography>
				<LencoTypography
					variant='Tiny_SemiBold'
					color={getColor('Gray 0')}
					p='4px 8px'
					mr='8px'
					sx={{
						borderRadius: '9px',
						backgroundColor: getColor('Yellow -3'),
					}}
				>
					{item.discountPercentage.displayValue}
				</LencoTypography>
				<LencoTypography variant='Small_SemiBold' color={getColor('Gray 0')}>
					₹{roundPrice(priceToDisplay)}
					{item?.lineOfProduct === 'RENT' ? (
						<span style={{ fontWeight: 400 }}>/mo</span>
					) : null}{' '}
				</LencoTypography>
			</FlexBox>
		</Box>
	);
};

export default CartItemSummary;
